module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-board-box",
    class: {
      'white-board-box-full': _vm.fullsrceen
    },
    style: (_vm.LandscapeStyle),
    on: {
      "click": _vm.whiteboardTap
    }
  }, [(_vm.direct_status == 'running') ? [_c('div', {
    style: ({
      height: _vm.Landscape ? '100%' : '56vw'
    }),
    attrs: {
      "id": "white-board"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBoardBottom),
      expression: "isShowBoardBottom"
    }],
    staticClass: "white-board-bottom"
  }, [(_vm.fullsrceen) ? _c('img', {
    staticClass: "fullsrceenBtn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "src": require("../../../statics/imgs/home/rotate.png")
    },
    on: {
      "click": _vm.LandscapeTap
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Landscape) ? [(_vm.fullsrceen) ? _c('img', {
    staticClass: "fullsrceenBtn",
    attrs: {
      "src": require("../../../statics/imgs/home/exitFullscreen.png")
    },
    on: {
      "click": _vm.fullScreenTap
    }
  }) : _c('img', {
    staticClass: "fullsrceenBtn",
    attrs: {
      "src": require("../../../statics/imgs/home/whiteboardfullsicon.png")
    },
    on: {
      "click": _vm.fullScreenTap
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullsrceen),
      expression: "!fullsrceen"
    }],
    staticClass: "positionIcon",
    attrs: {
      "src": require("../../../statics/imgs/home/switchIcon.png")
    },
    on: {
      "click": _vm.changeScreenPostionTap
    }
  })] : _c('p', {
    staticClass: "noDataTip"
  }, [_c('img', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/wbnothing.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ccc",
      "font-size": "14px",
      "margin": "10px 7px 0 0"
    }
  }, [_vm._v("暂无内容")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a631fc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/whiteboard.vue
// module id = 401
// module chunks = 0